import Axios from 'axios'
import getTokens from 'utilities/getTokens'
import { POLICIES } from './reducers'

export const fetchPolicies = (callback) => {
  const token = getTokens()

  return async (dispatch) => {
    dispatch({ type: POLICIES.LOADING })
    const res = await Axios({
      url: '/policies',
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (callback) callback(res)
        dispatch({ type: POLICIES.FETCHED, payload: res.data })
      })
      .catch((err) => {
        if (callback) callback(err, true)
        dispatch({ type: POLICIES.ERROR, payload: err.message })
      })
    return res
  }
}
